import { HTMLAttributes, ReactElement, useState } from 'react';

interface Props extends HTMLAttributes<HTMLDivElement> {
  className?: string;
  prefix?: string;
  children: string;
}

export default function CopyClick({
  className = 'p-2 flex items-center justify-between bg-blue-50 text-blue-600 rounded-lg ',
  children,
  prefix = '*',
  ...props
}: Props): ReactElement {
  const [isCopied, setIsCopied] = useState<boolean>(false);
  const handleCopy = async () => {
    await navigator?.clipboard?.writeText(children);
    setIsCopied(true);
    setTimeout(() => setIsCopied(false), 500);
  };

  return (
    <div title={children} className={`cursor-pointer ${className}`} {...props} onClick={handleCopy}>
      {prefix}
      {children.substring(children.length - 4)}
      <i className={isCopied ? 'icon-check' : 'icon-copy'} />
    </div>
  );
}
